import styled from 'styled-components';

import { Loading } from '../../../components/Loading';
import UI from '../../../domains/UI';
import { useProductIconQuery } from '../../../Product/graphql';

export type CartImageProps = {
	id: string;
	name: string;
};

export const CartImage: React.FC<CartImageProps> = ({ id, name }) => {
	const { data, error, loading } = useProductIconQuery({
		variables: { productId: id }
	});
	UI.actions.useApolloError(error);

	return (
		<>
			{loading ? (
				<ImageWrapper>
					<Loading size={25} />
				</ImageWrapper>
			) : (
				<Image
					alt={name}
					src={data?.product?.icon}
					title={name}
				></Image>
			)}
		</>
	);
};

const Image = styled.img`
	object-fit: contain;
	width: 60px;
	height: 60px;
	border: 1px solid #ddd3cd;
	border-radius: 5px;
`;

const ImageWrapper = styled.div`
	border: 1px solid #ddd3cd;
	border-radius: 5px;
	width: 60px;
	height: 60px;
`;
